import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

/** Home CTA box (sits next to the Verse of the Day) that invites reading the Quran. */
const ReadQuranBox = () => {
  const { t } = useTranslation();
  const { isDarkMode, isRTL } = useTheme();
  const navigate = useNavigate();

  let resumeName = null;
  const go = () => {
    try {
      const lr = JSON.parse(localStorage.getItem('quran_last_read') || '{}');
      const entries = Object.entries(lr);
      if (entries.length) {
        const [cid, data] = entries.sort((a, b) => (b[1].ts || 0) - (a[1].ts || 0))[0];
        navigate(`/quran/surah/${cid}?resume=${data.verse_key}`);
        return;
      }
    } catch { /* ignore */ }
    navigate('/quran');
  };

  try {
    const lr = JSON.parse(localStorage.getItem('quran_last_read') || '{}');
    const entries = Object.entries(lr);
    if (entries.length) resumeName = entries.sort((a, b) => (b[1].ts || 0) - (a[1].ts || 0))[0][1].chapter_name;
  } catch { /* ignore */ }

  return (
    <button
      data-testid="read-quran-box"
      onClick={go}
      className="relative rounded-2xl overflow-hidden h-full w-full text-left border"
      style={{
        borderColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'color-mix(in srgb, var(--p-hex) 18%, transparent)',
        background: isDarkMode
          ? 'linear-gradient(135deg, var(--p-hex), var(--card-dark-to))'
          : 'linear-gradient(135deg, var(--p-hex), var(--p-light-hex, var(--p-hex)))',
      }}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {/* glow */}
      <div className="absolute -bottom-8 -right-6 w-28 h-28 rounded-full pointer-events-none"
        style={{ background: '#fbbf24', opacity: 0.18, filter: 'blur(30px)' }} />

      <div className="relative z-10 p-3 flex flex-col h-full min-h-[128px] text-white">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center mb-2" style={{ background: 'rgba(255,255,255,0.18)' }}>
          <BookOpen className="w-5 h-5 text-white" />
        </div>
        <p className="text-sm font-bold leading-tight">{t('verse.readQuranTitle', 'Read the Quran')}</p>
        <p className="text-[11px] font-medium text-white/80 mt-0.5 line-clamp-2">
          {resumeName
            ? `${t('quranReader.continueReading', 'Continue Reading')} · ${resumeName}`
            : t('verse.readQuranSub', 'Nourish your heart with a few verses')}
        </p>
        <div className={`mt-auto flex items-center gap-1 text-xs font-bold ${isRTL ? 'flex-row-reverse' : ''}`}>
          <span>{resumeName ? t('quranReader.resumeBtn', 'Resume') : t('verse.startReading', 'Start reading')}</span>
          <ArrowRight className={`w-3.5 h-3.5 ${isRTL ? 'rotate-180' : ''}`} />
        </div>
      </div>
    </button>
  );
};

export default ReadQuranBox;
